// Iter-158.13.2.20e.17 — Script empty-state route resolver.
//
// The Script read surface is dual-mounted (legacy + Route 2 / H&M).
// Under the .20e.7 UI separation the canonical Script Setup lives
// at Production scope (`/beta/projects/:pid/script-setup`) — it is
// no longer surfaced from the H&M Settings page. The
// pre-.20e.17 empty-state message pointed every user at
// `${routeBase}/${projectId}/settings`, which on the H&M mount
// dead-links into a Settings page that does not carry a Script
// Setup section.
//
// This tiny pure helper resolves the correct target for each mount
// without touching authority, navigation, or the Settings page:
//
//   * legacy `apiBase === "/projects"` →
//     `${routeBase}/${projectId}/settings` (byte-identical).
//   * beta Route-2 `apiBase.startsWith("/beta/")` →
//     `/beta/projects/${projectId}/script-setup` (the existing
//     canonical Production surface).
//
// The empty-state also decides the copy shown to `canManage` users
// so beta users see clear guidance that Script is Production-owned
// while legacy users see the pre-existing "Settings → Script setup"
// hint.

export function computeScriptEmptyStateLink({ apiBase, projectId, routeBase } = {}) {
    const pid = String(projectId || "");
    const base = String(apiBase || "");
    const rBase = String(routeBase || "");
    const isBeta = base.startsWith("/beta/");
    if (!pid) {
        return { to: rBase || "/", isBeta, isCanonical: false, label: "" };
    }
    if (isBeta) {
        return {
            to: `/beta/projects/${pid}/script-setup`,
            isBeta: true,
            isCanonical: true,
            label: "Open Script Setup",
        };
    }
    return {
        to: `${rBase}/${pid}/settings`,
        isBeta: false,
        isCanonical: false,
        label: "Settings \u2192 Script setup",
    };
}
